// extracted by mini-css-extract-plugin
export default {"container":"oY-z","title":"pY-z","link":"qY-z"};